import Icon from '../components/Icon.vue'

Icon.register({"torii-gate":{"width":512,"height":512,"paths":[{"d":"M376.4 32H135.6A303.2-303.2 0 0 0 0 0V96C0 113.7 14.3 128 32 128H64V192H16C7.2 192 0 199.2 0 208V240C0 248.8 7.2 256 16 256H64V496C64 504.8 71.2 512 80 512H112C120.8 512 128 504.8 128 496V256H384V496C384 504.8 391.2 512 400 512H432C440.8 512 448 504.8 448 496V256H496C504.8 256 512 248.8 512 240V208C512 199.2 504.8 192 496 192H448V128H480C497.7 128 512 113.7 512 96V0A303.2-303.2 0 0 0 376.4 32zM128 128H224V192H128V128zM384 192H288V128H384V192z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/torii-gate.js
// module id = null
// module chunks = 